<template>
  <div class="chat">
    <iframe src="https://lifefe.betards.ninja/telegram/index.html" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: 'Chat'
};
</script>
<style lang="scss" scoped>
.chat {
  background-color: white;
  position: relative;
}
iframe {
  position: absolute;
  height: 0;
  width: 0;
  min-height: calc(100% - 20px);
  max-height: calc(100% - 20px);
  min-width: 100%;
  max-width: 100%;
}
</style>
